import { createContext, useContext } from 'react';

export const TenantContext = createContext({
  tenantId: 'tenant_default',
  regionId: null,
  role: null,
  isSuperAdmin: false,
  availableTenants: [],
  setTenantId: () => {},
  setRegionId: () => {},
  refreshTenantContext: async () => {},
});

export const useTenant = () => useContext(TenantContext);

